namespace TabAurous.Production {
    export namespace WIPTransactionReceiptMaterialService {
        export const baseUrl = 'Production/WIPTransactionReceiptMaterial';

        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPTransactionReceiptMaterial/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPTransactionReceiptMaterialService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
